import { faSave, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { useFormikContext } from 'formik'
import React from 'react'
import { DatePicker, Dropdown, Input } from 'src/components/Forms'
import YesNo from 'src/components/Forms/YesNo'
import { Body, Footer } from 'src/components/theme/Models/Modal'
import { UseLookupsReturn } from './useLookups'
import { Values } from './FormContext'
import { createDropdownOptions } from 'src/helpers/formHelpers'
import { Row, Col } from 'reactstrap'

interface FormProps {
  toggle: () => void
  isLoading?: boolean
  hasError?: boolean
  disableSave?: boolean
  lookups?: UseLookupsReturn
}

const getStatusLabel = (id: string, statuses: UseLookupsReturn['statuses']): string => {
  const status = statuses.find((s) => s._id === id)
  return status?._category?.name ?? ''
}

const Form: React.FC<FormProps> = (props) => {
  const { hasError, toggle, isLoading, disableSave } = props
  const {
    contracts,
    clearances,
    contractTypes,
    statuses,
    priorities,
    programManagers,
    hiringManagers,
    exemptStatuses,
    workSettings
  } = props.lookups ?? {}
  const { handleSubmit, values } = useFormikContext<Values>()
  return (
    <>
      <Body error={{
        error: 'There was an issue updating the position details.',
        show: hasError ?? false
      }}
      >
        <Row className='g-lg-4'>
          <Col className='border-lg-end' lg={4} md={12}>
            <Input required type='text' name='title' label='Title' />
            <Dropdown name='contract' label='Contract' options={contracts ?? []} />
            <Dropdown name='contract_type' label='Contract Type' options={contractTypes ?? []} />
            <Dropdown name='status' label='Status' options={createDropdownOptions(statuses ?? [])} />
            {getStatusLabel(values.status, statuses ?? []) === 'Filled' && <DatePicker name='filled_date' label='Filled On' />}
            {getStatusLabel(values.status, statuses ?? []) === 'Closed' && <DatePicker name='closed_date' label='Closed On' />}
            <Dropdown name='exemptStatus' label='Exempt Status' options={exemptStatuses ?? []} />
            <Input required type='number' name='numberOfOpenings' label='Number of Openings' />
          </Col>
          <Col className='border-lg-end' lg={4} md={12}>
            <Dropdown name='program_manager' label='Program Manager' options={programManagers ?? []} />
            <Dropdown name='hiring_manager' label='Hiring Manager' options={hiringManagers ?? []} />
            <Dropdown name='required_clearance' label='Clearance' options={clearances ?? []} />
            <Dropdown required name='workSetting' label='Work Setting' options={workSettings ?? []} />
            <Input type='text' name='location' label='Location' />
          </Col>
          <Col lg={4} md={12}>
            <YesNo name='backfill' label='Backfill' />
            <YesNo name='direct_hire' label='Direct Hire' />
            <YesNo name='temp_to_perm' label='Temp To Perm' />
            <Input type='text' name='keywords' label='Keywords' />
            <Dropdown name='priority' label='Priority' options={priorities ?? []} />
          </Col>
        </Row>
      </Body>
      <Footer
        toggle={toggle}
        onAction={handleSubmit}
        action={{
          text: 'Save',
          icon: isLoading === true ? faSpinner : faSave,
          color: 'primary',
          disabled: disableSave === true || isLoading
        }}
      />
    </>
  )
}

export default Form
